module.exports = __webpack_public_path__ + "static/media/public_art.2b194f94.png";